import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-table-legend',
  templateUrl: './table-legend.component.html',
  styleUrls: ['./table-legend.component.scss'],
  standalone: false,
})
export class TableLegendComponent implements OnInit {
  @Input()
  items: number[] = [0, 1, 2];

  allValues: { [id: number]: any } = {
    0: {
      label: '= Bestätigt',
      class: 'green',
      icon: 'checkmark-circle-outline',
    },
    1: {
      label: '= In Bearbeitung',
      class: 'orange',
      icon: 'checkmark-circle-outline',
    },
    2: {
      label: '= Fehlerhaft',
      class: 'red',
      icon: 'close-circle-outline',
    },
    3: {
      label: '= Entwurf',
      class: '',
      icon: 'document-text-outline',
    },
    4: {
      label: '= Geprüft',
      class: 'green',
      icon: 'checkmark-circle-outline',
    },
    5: {
      label: '= Prüfung notwendig',
      class: 'red',
      icon: 'close-circle-outline',
    },
    6: {
      label: '= Prüfung notwendig',
      class: 'orange',
      icon: 'checkmark-circle-outline',
    },
    7: {
      label: '= Abgelehnt',
      class: 'red',
      icon: 'close-circle-outline',
    },
    8: {
      label: '= Bautagesbericht',
      class: '',
      icon: 'clipboard-outline',
    },
    9: {
      label: '= Fahrtenbericht',
      class: '',
      icon: 'speedometer-outline',
    },
    10: {
      label: '= Arbeitszeitbericht',
      class: '',
      icon: 'time-outline',
    },
    11: {
      label: '= Arbeitszeit',
      class: 'blue',
      icon: 'square',
    },
    12: {
      label: '= Abwesend',
      class: 'website-orange',
      icon: 'square',
    },
    13: {
      label: '= Anhänge vorhanden',
      class: '',
      icon: 'attach-outline',
    },
  };

  constructor() {}

  ngOnInit() {}
}
